import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as BaseLink, useParams } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { ROUTES } from '../../core/router/routes';
import { ArticleParams } from '../../features/article/model/articleModel';
import { useGetArticlesInCategoryQuery } from '../../features/article/api/articleApi';
import './moreArticlesInCategory.scss';

interface MoreArticlesInCategoryProps {
  categoryId: string;
}

const MoreArticlesInCategory: FC<MoreArticlesInCategoryProps> = ({ categoryId }) => {
  const { t } = useTranslation();
  const params = useParams<ArticleParams>();
  const { data: publishedArticlesInCategory, isSuccess } = useGetArticlesInCategoryQuery({
    id: categoryId,
  });
  const articleLimit = 5;

  let publishedArticlesInCategoryWithoutDisplayed;
  let limitedArticles;
  let moreArticlesAvailable;

  if (isSuccess) {
    publishedArticlesInCategoryWithoutDisplayed = publishedArticlesInCategory.filter(
      (article) => article.id !== parseInt(params.id!),
    );
    limitedArticles = publishedArticlesInCategoryWithoutDisplayed.slice(0, articleLimit);
    moreArticlesAvailable = publishedArticlesInCategoryWithoutDisplayed.length > articleLimit;
  }

  return (
    <>
      {isSuccess && limitedArticles && limitedArticles.length ? (
        <section className="MoreArticlesInCategory-Section">
          <h3>
            {t('more_articles_in_category.title')} {publishedArticlesInCategory[0].category.name}
          </h3>
          <ul>
            {limitedArticles.map(({ title, id }) => {
              return (
                <li key={id}>
                  <Link
                    to={ROUTES.ARTICLE.SHOW.replace(':id', id as unknown as string)}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    component={BaseLink}
                  >
                    {title}
                  </Link>
                </li>
              );
            })}
            {moreArticlesAvailable && (
              <li key={categoryId}>
                <Link
                  to={ROUTES.CATEGORY.ARTICLE.replace(':id', categoryId as unknown as string)}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  component={BaseLink}
                >
                  {t('more_articles_in_category.other_articles_from_categories')}{' '}
                  {publishedArticlesInCategory[0].category.name}
                  <FontAwesomeIcon icon={faChevronRight as IconProp} size={'xs'} />
                </Link>
              </li>
            )}
          </ul>
        </section>
      ) : (
        <></>
      )}
    </>
  );
};

export default MoreArticlesInCategory;
